import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  $('input.js-user-profile-photo-field').on('change', function() {
    let p = $(this).parent();
    let v = $(this).val();

    p.find('.js-browse-label-selected-file').html(String(v).replace(/^.*[\\\/]/, ''));
  });
});
